import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AgendaSigningRepository } from '../domain/repository/agenda-signing.repository';
import { AGENDA_SIGNING_REPOSITORY } from './agenda-signing.tokens';

@Injectable()
export class CreateReservationUseCase {
  constructor(@Inject(AGENDA_SIGNING_REPOSITORY) private readonly repository: AgendaSigningRepository) { }

  execute(payload: any): Observable<any> {
    return this.repository.createReservation(payload);
  }
}
